function getBasePath(environment) {
    const basePaths = {
        dev: '//localhost',
        qa: '//mwc-cdn-qa.morningstar.com/components',
        uat: '//mwc-cdn-uat.morningstar.com/components',
        prod: '//mwc-cdn.morningstar.com/components',
    };
    const basePath = basePaths[environment];
    if (!basePath) {
        throw new Error(`Specified CDN environment '${environment}' does not exist.`);
    }
    return basePath;
}

function getBundleFiles(environment, component, version, instid) {
    // todo: remove the instid. However, we need a solution to solve the client special styles and dom
    if (component === 'angular') {
        return [`//ajax.googleapis.com/ajax/libs/angularjs/${version}/angular.min.js`];
    }
    const basePath = getBasePath(environment);
    const filename = [basePath, component, version, instid, component].join('/');
    return [`${filename}-bundle.js`, `${filename}-bundle.css`];
}

function getLibraryBasePath(environment) {
    return getBasePath(environment).replace('components', 'lib');
}

function getClientBundlesBasePath(environment) {
    return getBasePath(environment).replace('components', 'client-bundles');
}

/**
 * Get the chunk file path for a component
 * @param {*} environment
 * @param {*} component
 * @param {*} version
 * @param {*} instid
 */
function getChunkFilePath(environment, component, version, instid) {
    const basePath = getBasePath(environment);
    const path = [basePath, component, version, instid].join('/');
    return `${path}/`;
}

export {
    getBasePath,
    getBundleFiles,
    getChunkFilePath,
    getClientBundlesBasePath,
    getLibraryBasePath,
};



// WEBPACK FOOTER //
// ./src/bundle-helper.js